// Função para alternar entre tela cheia e modo normal
export function toggleFullscreen() {
  if (
    !document.fullscreenElement &&
    !document.fullscreenElement &&
    !document.fullscreenElement &&
    !document.fullscreenElement
  ) {
    var element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.requestFullscreen) {
      element.requestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}
